import { cva, type VariantProps } from 'class-variance-authority';
import type { AnchorHTMLAttributes } from 'react';
import { cn } from '../../../lib/utils';

const externalLinkVariants = cva('', {
  variants: {
    variant: {
      default: '',
      inline: 'underline hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
    },
  },
  defaultVariants: { variant: 'default' },
});

type ExternalLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'rel'> &
  VariantProps<typeof externalLinkVariants> & {
    href: string;
  };

function ExternalLink({ href, variant, className, children, ...props }: ExternalLinkProps) {
  return (
    <a {...props} className={cn(externalLinkVariants({ variant }), className)} href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
}

export type { ExternalLinkProps };
export { ExternalLink, externalLinkVariants };
